import { render } from "./ProgAgreement.vue?vue&type=template&id=f10f5488"
import script from "./ProgAgreement.vue?vue&type=script&lang=js"
export * from "./ProgAgreement.vue?vue&type=script&lang=js"

import "./ProgAgreement.vue?vue&type=style&index=0&id=f10f5488&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__